import { init as initApm } from '@elastic/apm-rum';
import { getFeatureFlag } from '@platform24/clinic-utils';
import { getAuthHeaders } from '@platform24/clinician-auth';

import { getLastClickedElement, getUsefulElementName } from './userInteraction';

const enableApm = getFeatureFlag('FF_ENABLE_ELASTIC_APM');

declare global {
  interface Window {
    __clinic_set_elastic_apm_context?: (context: {
      practitionerId: string;
      practitionerRole: string | null;
      careUnitId: string;
      careUnitName: string;
      careProviderId: string;
      careProviderName: string;
      partnerId: string;
      partnerName: string;
    }) => void;

    __frontendConfig?: Record<string, string>;
  }
}

let isLoggedIn = false;
let cachedAuthHeaders: Record<string, string> = {};
const cacheAuthHeaders = () => {
  if (isLoggedIn) {
    void getAuthHeaders().then(headers => {
      cachedAuthHeaders = headers;
    });
  }
};

const apm = initApm({
  active: enableApm,

  apiVersion: 3,

  apmRequest: ({ xhr }) => {
    if (Object.keys(cachedAuthHeaders).length === 0) {
      return false;
    }

    for (const [name, value] of Object.entries(cachedAuthHeaders)) {
      xhr.setRequestHeader(name, value);
    }

    // Refresh headers in the background for subsequent requests
    cacheAuthHeaders();

    return true;
  },

  disableInstrumentations: [
    // Note: there's a slight possibility of PII exposure with this, but not confirmed yet
    // Uncomment this if/when confirmed:
    // 'error',
  ],

  serviceName: 'clinic-ui',

  serverUrl: '/rest',
  serverUrlPrefix: '/elastic-apm-rum-v3',

  transactionSampleRate: parseFloat(window.__frontendConfig?.FRONTEND_CONFIG_APM_TRANSACTION_SAMPLE_RATE ?? '0.01'),
});

apm.observe('transaction:start', transaction => {
  if (transaction.type === 'user-interaction') {
    // Ensure that this runs after getLastClickedElement() starts returning the right value
    setTimeout(() => {
      transaction.name = `Click - ${getUsefulElementName(getLastClickedElement())}`;
    }, 0);
  }
});

// This callback will be executed by a descendant MFE later, when authentication is complete and context data becomes available
window.__clinic_set_elastic_apm_context = context => {
  apm.setCustomContext(context);
  apm.setUserContext({ id: context.practitionerId });

  isLoggedIn = true;
  cacheAuthHeaders();
};
